import {
  SET_USER_IS_ADMIN,
  SET_ADMIN_DATA,
  SET_ADMIN_USERS,
  SET_ADMIN_TASKS,
  SET_ADMIN_SESSIONS,
  SET_ADMIN_STATS,
  SET_ADMIN_FEEDBACK,
  SET_ADMIN_CONVERSATIONS,
  SET_ADMIN_LOADING,
} from "../constants/admin";

export const setUserIsAdmin = (isAdmin) => {
  return {
    type: SET_USER_IS_ADMIN,
    isAdmin,
  };
};

export const setAdminData = (data) => {
  return {
    type: SET_ADMIN_DATA,
    data,
  };
};

// Partial update actions
export const setAdminUsers = (users) => {
  return {
    type: SET_ADMIN_USERS,
    users,
  };
};

export const setAdminTasks = (tasks) => {
  return {
    type: SET_ADMIN_TASKS,
    tasks,
  };
};

export const setAdminSessions = (recentVisits) => {
  return {
    type: SET_ADMIN_SESSIONS,
    recentVisits,
  };
};

export const setAdminStats = (analytics) => {
  return {
    type: SET_ADMIN_STATS,
    analytics,
  };
};

export const setAdminFeedback = (feedback) => {
  return {
    type: SET_ADMIN_FEEDBACK,
    feedback,
  };
};

export const setAdminConversations = (conversations) => {
  return {
    type: SET_ADMIN_CONVERSATIONS,
    conversations,
  };
};

// Loading state action - key can be: users, tasks, sessions, stats, feedback, conversations
export const setAdminLoading = (key, isLoading) => {
  return {
    type: SET_ADMIN_LOADING,
    key,
    isLoading,
  };
};
